import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_3 = { class: "col-lg-8 fv-row" }
const _hoisted_4 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_7 = { class: "col-lg-8 fv-row" }
const _hoisted_8 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "col-form-label fw-normal fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.tratamiento.text), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.menorData.nombre + " " + _ctx.menorData.apellidos), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.fechaNacimiento.label")), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.menorData.fechaNacimiento)), 1)
      ])
    ])
  ], 64))
}